import { Building2 } from "lucide-react";
import { useHeroContent } from "@/hooks/use-supabase-data";

const fallbackHeroImage =
  "https://images.unsplash.com/photo-1523419409543-0c1df022bdd1?auto=format&fit=crop&w=1600&q=80";

export function Hero() {
  const { heroContent } = useHeroContent();

  const backgroundImage =
    heroContent?.background_image_url?.trim() || fallbackHeroImage;
  const title = heroContent?.title?.trim() || "Sandalpur Village";
  const subtitle =
    heroContent?.subtitle?.trim() ||
    "A Thriving Community Committed to Progress, Unity, and Service";

  return (
    <section
      className="relative h-[60vh] md:h-[70vh] w-full overflow-hidden"
      data-testid="section-hero"
    >
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(${backgroundImage})`,
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/60" />
      </div>

      <div className="relative h-full flex flex-col items-center justify-center text-center px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-center gap-2 sm:gap-3 mb-4">
          <Building2
            className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 text-white flex-shrink-0"
            data-testid="icon-village"
          />
          <h1
            className="font-poppins text-3xl sm:text-4xl md:text-6xl font-bold text-white"
            data-testid="text-village-name"
          >
            {title}
          </h1>
        </div>

        <p
          className="font-inter text-lg md:text-xl text-white/90 max-w-2xl"
          data-testid="text-village-tagline"
        >
          {subtitle}
        </p>

        <div className="mt-8 flex items-center gap-3">
          <div
            className="w-3 h-8 bg-primary rounded-sm"
            data-testid="decoration-saffron"
          />
          <div
            className="w-3 h-8 bg-white rounded-sm"
            data-testid="decoration-white"
          />
          <div
            className="w-3 h-8 bg-secondary rounded-sm"
            data-testid="decoration-green"
          />
        </div>
      </div>
    </section>
  );
}
